<template>
  <div class="wrapper">


    <CModal
            :show.sync="spinnerModal"
            :no-close-on-backdrop="false"
            color="transparent"
            border-color="primary"
    >

      <div align="center">

        {{$t('dialogs.pleaseWait')}}

      </div>
<div align="center">

        <CSpinner
                color="primary"
                style="width:4rem;height:4rem;"
        />
      </div>

      <template #footer>
      </template>
    </CModal>
    <!-- Modal Component -->
<!--    <CAlert-->
<!--        :show.sync="alertCountDown"-->
<!--        closeButton-->
<!--        :color="alert_color"-->
<!--    >-->
<!--      {{message_api}}-->
<!--      <CProgress-->
<!--          color="info"-->
<!--          :max="alertSecs"-->
<!--          :value="alertCountDown"-->
<!--          height="4px"-->
<!--      />-->
<!--    </CAlert>-->
    <!-- Modal Component -->

    <CModal
            :title="title"
            color="danger"
            :show.sync="dangerModal"
    >
      {{message_api}}
      <template #footer>
        <CButton @click="dangerModal = false" color="danger">{{$t('buttons.ok')}}</CButton>
      </template>
    </CModal>
    <!-- Modal Component -->

    <CModal
            :title="title"
            color="success"
            :show.sync="successModal"
    >
      {{message_api}}
      <template #footer>
        <CButton @click="successModal = false" color="primary">{{$t('buttons.close')}}</CButton>
      </template>
    </CModal>


    <CModal
            :show.sync="confirmModal"
            :no-close-on-backdrop="true"
            :centered="true"
            :title="title"
            size="sm"
            color="dark"
    >
      <td v-html="message_confirm"></td>
      <template #header>
        <h6 class="modal-title">{{title}}</h6>
        <CButtonClose @click="confirmModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="confirmed_request(true)"
                 color="danger"
        >{{buttons[0]}}
        </CButton>
        <CButton
                @click="confirmed_request(false)"
                color="success"
        >{{$t("buttons.cancel")}}
        </CButton>
      </template>
    </CModal>


  </div>

</template>

<script>
  import {bus} from '../../../main';
  import Vue from 'vue';
  import VueToast from 'vue-toast-notification';
  import 'vue-toast-notification/dist/theme-sugar.css';
  Vue.use(VueToast);
  //Vue.$toast.open({/* options */});

  export default {
    name: 'Modals',
    data() {
      return {

        dangerModal: false,
        successModal: false,
        confirmModal: false,
        spinnerModal: false,
fixedToasts : 0,
        alertCountDown:true,
        alertSecs:3,
        alert_color:'info',
        confirmed_request_tag: '',
        title: '',
        title2: 'salam hamid',
        message_api: '',
          message: '',
          message_confirm: '',

          buttons: [],
        buttons_onclick: [],
      }
    },mounted() {
          bus.$on('show_spinner', (data) => {
              // alert(data);
              if(data== "true"){
                  // this.spinnerModal = true;
               try{
                 this.$root.loading_component.loading = true;

               }catch (e) {
                 console.log("error at show loading")
               }
              }else{
                  // this.spinnerModal = false;
                try{
                  this.$root.loading_component.loading = false;

                }catch (e) {
                  console.log("error at show loading")
                }
              }
          });
      bus.$on('show_danger_modal', (data) => {
        // alert(data);
       this.show_danger_modal(data[0],data[1])
      });
    }, methods: {
      show_danger_modal(title, text) {
        this.title = title;
        this.message_api = text;
        // this.buttons = buttons;
        this.dangerModal = true;
      },
      show_loading_modal() {

        this.spinnerModal = true;
      },
      show_success_modal(title, text) {
        this.title = title;
        this.message_api = text;
        this.successModal = true;
      },
      show_api_response_modals(res_data){
        if(res_data.data.statusCode!=0){
          this.alert_color="danger"
          // this.show_danger_modal(this.$t("dialogs.error"),res_data.data.message);
          this.message_api = res_data.data.message;
          this.title = this.$t('dialogs.error');
          Vue.$toast.open({
            message: res_data.data.message,
            type: 'error',
            duration:5000,
            // all of other options may go here
          });

        }else{
          this.alert_color="success"
          this.message_api = res_data.data.message;
          this.title = this.$t('dialogs.ok');
          Vue.$toast.open({
            message: res_data.data.message,
            type: 'success',
            // all of other options may go here
          });

          // this.show_success_modal(this.$t("dialogs.ok"),res_data.data.message);

        }
        // this.alertCountDown = this.alertSecs;

        // this.fixedToasts ++;
        // this.alertCountDown = true;
      },

      show_validate_errors(errors){
          this.alert_color="danger"
          // this.show_danger_modal(this.$t("dialogs.error"),res_data.data.message);
         var message = "";
          for(var xz=0;xz<errors.length;xz++){
              message = message+"\n"+errors[xz];
          }
          // this.title = this.$t('dialogs.error');
          Vue.$toast.open({
            message: message,
            type: 'error',
              duration:5000
            // all of other options may go here
          });

      },
      show_confirm_modal(title, text, buttons,bus_tag) {
        this.title = title;
        this.message_confirm = text;
        this.buttons = buttons;
        this.confirmed_request_tag = bus_tag;
// this.buttons_onclick = onclicks;
        this.confirmModal = true;
      },
      confirmed_request(status) {
        this.confirmModal = false;
        if (status) {
          // bus.$emit(this.confirmed_request_tag, 'changed header');
          bus.$emit(this.confirmed_request_tag, 'true');
          this.confirmed_request_tag = "";

        }else{
          bus.$emit(this.confirmed_request_tag, 'false');
          this.confirmed_request_tag = "";

        }
      }
    }

  }
</script>
